import { css } from 'lit';

export const facet2OnDarkStyles = css`
    --_facet-2__aspect-ratio--mobile: 1;
    --_facet-2__width--mobile: var(--_image__facet-2__width);
    --_facet-2__margin--mobile: var(--_image__facet-2__margin);

    --_facet-2-md__display--md: none;
    --_facet-2-lg__display--lg: none;

    --_facet-2__onDark: block;
    --_facet-2-lg__display--lg: none;

    --_facet-2__clip-path--mobile: polygon( 11.1% 20.55%,42.225% 2.575%,42.225% 2.575%,43.703% 1.826%,45.234% 1.243%,46.804% 0.827%,48.401% 0.577%,50.009% 0.494%,51.617% 0.577%,53.211% 0.827%,54.778% 1.243%,56.303% 1.826%,57.775% 2.575%,81.125% 16.05%,81.125% 16.05%,82.515% 16.952%,83.786% 17.984%,84.932% 19.135%,85.946% 20.394%,86.822% 21.747%,87.553% 23.183%,88.133% 24.691%,88.555% 26.259%,88.813% 27.874%,88.9% 29.525%,88.9% 65.475%,29.975% 99.5%,11.1% 88.525%,11.1% 20.55% );

    --_facet-2__onDark--xl: block;
`;
